import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LoginService } from './../../login/shared/login.service';
import { environment } from './../../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../login/shared/login.service";
var BreaktimeCebuService = /** @class */ (function () {
    function BreaktimeCebuService(http, authenticate) {
        this.http = http;
        this.authenticate = authenticate;
    }
    BreaktimeCebuService.prototype.getStaffBreakTime = function (staffId, date) {
        var headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken() });
        var params = new HttpParams();
        params = params.append('staffId', staffId.toString());
        params = params.append('date', date);
        var options = { headers: headers, params: params };
        console.log(options);
        return this.http.get(environment.SERVER_URL + '/cebu_break', options).pipe(map(this.extractData), catchError(this.handleError));
    };
    BreaktimeCebuService.prototype.startBreakTime = function (staffId, duration) {
        var headers = new HttpHeaders({
            'Authorization': this.authenticate.getToken(),
            'Content-Type': 'application/json'
        });
        var body = {
            "staffId": staffId,
            "action": "start",
            "duration": duration
        };
        var options = { headers: headers };
        return this.http.post(environment.SERVER_URL + '/cebu_break', body, options);
    };
    BreaktimeCebuService.prototype.stopBreakTime = function (staffId) {
        var headers = new HttpHeaders({
            'Authorization': this.authenticate.getToken(),
            'Content-Type': 'application/json'
        });
        var body = {
            "staffId": staffId,
            "action": "stop"
        };
        var options = { headers: headers };
        return this.http.put(environment.SERVER_URL + '/cebu_break/stop', body, options);
    };
    BreaktimeCebuService.prototype.timesUp = function (staffId) {
        var headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken() });
        var options = { headers: headers };
        this.http.put(environment.SERVER_URL + ("/cebu_break/timesup?staffId=" + staffId), options).pipe(map(this.extractData), catchError(this.handleError));
        return;
    };
    BreaktimeCebuService.prototype.extractData = function (res) {
        var body = res;
        return body.data || {};
    };
    BreaktimeCebuService.prototype.handleError = function (error) {
        console.log(error);
        var errMsg;
        if (error) {
            var body = error || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return observableThrowError(errMsg);
    };
    BreaktimeCebuService.ngInjectableDef = i0.defineInjectable({ factory: function BreaktimeCebuService_Factory() { return new BreaktimeCebuService(i0.inject(i1.HttpClient), i0.inject(i2.LoginService)); }, token: BreaktimeCebuService, providedIn: "root" });
    return BreaktimeCebuService;
}());
export { BreaktimeCebuService };
